import React from 'react'
import { Link, Badge } from '../../common'

export function Resource({ data }) {
  let params = window.location.pathname.split('/')
  const coursenum = params[3]
  const ResourceSelectionComponent = {
    current: { Component: Badge, children: 'Current Resource', props: {} },
    other: {
      Component: Link,
      children: {},
      props: {
        target: `/instructor/lti_dashboard/${data.course_number}`,
        text: 'Switch to this Resource',
      },
    },
  }
  const { Component, props, children } =
    ResourceSelectionComponent[
      data.course_number === coursenum ? 'current' : 'other'
    ]

  return (
    <div className="border rounded p-3" style={{ maxWidth: '400px' }}>
      <h4 className="p-0 m-0">{data.book_title}</h4>
      <div className="mt-2 mb-2">
        <div className="d-flex ">
          <p className="m-0 text-secondary font-weight-light">Child Course Number:</p>
          <p className="m-0 pl-2 text-secondary font-weight-light">
            {data.course_number}
          </p>
        </div>
        <div className="d-flex">
          <p className="m-0 text-secondary font-weight-light">Child Course Title:</p>
          <p className="m-0 pl-2 text-secondary font-weight-light">
            {data.course_title}
          </p>
        </div>
      </div>
      <Component {...props}>{children}</Component>
    </div>
  )
}
